import { module } from 'modujs';
import { gsap } from "gsap";

export default class extends module {
    constructor(m) {
        super(m);

        this.introTop = this.el.querySelector('.c-projects_intro_top .c-heading.-h3.-border');
        this.introCenter = this.el.querySelector('.c-projects_intro_center');
        this.introBottomTopNum = this.el.querySelector('.c-projects_intro_bottom .c-text-num_value');
        this.introBottomTopContent = this.el.querySelector('.c-projects_intro_bottom .c-text-num_content');
        this.introBottomContent = this.el.querySelector('.c-projects_intro_bottom .c-heading.-h5');

        this.tlBg = gsap.timeline({ paused: true });
        this.tlBg.fromTo(
            ['.c-projects_intro_top', '.c-projects_intro_center', '.c-projects_intro_bottom'],
            { opacity: 1 },
            { opacity: 0, duration: 0.25, ease: 'none' },
            0.25
        );
        this.tlBg.fromTo(
            '.c-projects_backgrounds_item',
            { y: '90vh', x: (i) => { return (i%2 == 0) ? '-15vw' : '15vw' }, rotate: (i) => { return (i%2 == 0) ? 10 : -10 } },
            { y: 0, x: 0, rotate: 0, duration: 0.8, ease: "power2.inOut", stagger: { each: 0.1, from: 'end' } },
            0
        );
        this.tlBg.add('zoom');
        this.tlBg.fromTo(
            '.c-projects_backgrounds_item',
            { scale: 0.5 },
            { scale: 1, duration: 1, ease: "power2.inOut", stagger: { each: 0.1, from: 'end' } },
            'zoom-=0.1'
        );
        this.tlBg.fromTo(
            '.c-projects_backgrounds_mask',
            { opacity: 0 },
            { opacity: 1, duration: 0.3, ease: "none" },
            'zoom+=0.5'
        );

        window.addEventListener('projectsBg', (e) => {
            const { target, progress } = e.detail;
            if (this.tlBg) {
                this.tlBg.progress(progress);
            }
        });
    }

    init() {
        this.el.querySelectorAll('.c-projects_list_item').forEach(elt => {
            elt.addEventListener('mouseenter', (e) => {
                if (this.el.querySelector('.c-projects_backgrounds_item.-active')) {
                    let oldCover = this.el.querySelector('.c-projects_backgrounds_item.-active');
                    oldCover.classList.remove('-active');
                    if (oldCover.querySelector('video')) {
                        oldCover.querySelector('video').pause();
                    }
                }

                let newCover = this.el.querySelector('.c-projects_backgrounds_item[data-project="' + elt.getAttribute('data-project') + '"]');
                newCover.classList.add('-active');
                if (newCover.querySelector('video')) {
                    newCover.querySelector('video').play();
                }
            })
        });
    }

    playIntro(e) {
        if (e.way == 'enter') {
            let tl = gsap.timeline();
            tl.call(() => { this.introTop.classList.add('is-inview'); }, null, 0);
            tl.fromTo(
                this.introCenter.querySelectorAll('.char'),
                { y: '100%', scaleY: 0, },
                { y: 0, scaleY: 1, duration: 0.8, ease: 'elastic.out(1,0.8)', stagger: { from: 'center', each: 0.04 } },
                0.3
            );
            tl.call(() => { this.introBottomTopNum.classList.add('is-inview'); }, null, 0.4);
            tl.call(() => { this.introBottomTopContent.classList.add('is-inview'); }, null, 0.6);
            tl.call(() => { this.introBottomContent.classList.add('is-inview'); }, null, 0.8);

        } else {
            // let tl = gsap.timeline();
            // tl.call(() => { this.introTop.classList.remove('is-inview'); }, null, 0);
            // tl.to(
            //     this.introCenter.querySelectorAll('.char'),
            //     { y: '100%', scaleY: 0, duration: 0.6, ease: 'power4.out' },
            //     0
            // );
            // tl.call(() => { this.introBottomTopNum.classList.remove('is-inview'); }, null, 0);
            // tl.call(() => { this.introBottomTopContent.classList.remove('is-inview'); }, null, 0);
            // tl.call(() => { this.introBottomContent.classList.remove('is-inview'); }, null, 0);
        }
    }
}
